function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: "8",
  cy: "8",
  r: "8",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 5v3.459a.1.1 0 00.03.07L10.5 11",
  stroke: "#6B1BE3",
  strokeWidth: "2",
  strokeLinecap: "round"
})));